import {useEffect} from 'react';
import {
  Header,
  Footer,
  Socials,
  Intro,
  Story,
  Realms,
  WhatIsMocaverse,
  Faq,
} from "../components";

const Home = () => {
  useEffect(() => {
    document.body.classList.add('home');
  });

  return (
    <>
    <div className="bg"/>
    <div className="stars"/>
      <main>
        <Header/>
        <Intro />
        <Story />
        <Realms />
        <WhatIsMocaverse />
        <Faq />
      <Footer />
      <Socials />
      </main>
    </>
  );
};

export default Home;
